<script>
export default {
  name: 'UiInviteDialog',
  props: {
    variant: {
      type: String,
      required: false,
      default: 'modal', // 'modal' | 'popover'
    },
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
      },
    }
  },
  methods: {
    sendInvite() {
      console.log('send!', this.form)
      // @TODO need to send invite!!!
      this.$store.commit('ui/dialog', { dialog: 'invite', show: false })
    },
  },
}
</script>

<template>
  <div
    class="ui-dialog ff-regular fs-regular"
    :class="variant === 'modal' ? 'ui-dialog-modal position-absolute top-35 start-50 translate-middle' : 'ui-dialog-popover'"
  >
    <h3 class="ff-regular">Invite to Vyby!</h3>
    <form @submit.stop.prevent="sendInvite">
      <div class="form-group mb-2 d-flex flex-column">
        <label>Name</label>
        <input type="text" required placeholder="Name" v-model="form.name" />
      </div>
      <div class="form-group mb-2 d-flex flex-column">
        <label>Phone</label>
        <input
          type="text"
          placeholder="Phone"
          :required="!form.phone && !form.email"
          v-model="form.phone"
        />
      </div>
      <div class="form-group mb-2 d-flex flex-column">
        <label>Email</label>
        <input
          type="text"
          placeholder="Email"
          :required="!form.phone && !form.email"
          v-model="form.email"
        />
      </div>
      <div class="text-center">
        <button type="submit" class="btn btn-vyby ff-regular">Invite!</button>
      </div>
    </form>
  </div>
</template>

<style scoped lang="scss">
.ui-dialog {
  width: 350px;
  text-align: center;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.6);
}

.ui-dialog-modal {
  background: #fff;
}

.ui-dialog-popover {
  background: transparent;
  border: none;
  width: 100%;
  padding: 0;
  text-align: left;
  color: #fff;
}

.form-group {
  margin-left: 15px;
  text-align: left;

  label {
    display: none;
  }
}

input {
  min-width: 100px;
  max-width: 300px;
}

.ui-dialog-popover input {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  padding: 10px 12px;
  outline: none;
}

.ui-dialog-popover input::placeholder {
  color: rgba(255, 255, 255, 0.55);
}
</style>
